__turbopack_context__.v({
  "toastsContainer": "Toaster-module-scss-module__Of8Frq__toastsContainer",
});
